import { SiKubernetes } from 'react-icons/si'

export const GoogleTech = () => {
    return (
        <div>
        <SiKubernetes />
        <h4>GKE</h4>
        </div>
    )
}